import { BRAND_COLOR } from "@/app/layout/LayoutConstants";
import Ribbon from "../common/Ribbon";
import { Box } from "@mui/material";

export interface AdLabelRibbonProps {
  isUrgent: boolean;
  isSold: boolean;
  adTypeLabel: string;
}

export default function AdLabelRibbon({
  ad,
  alwaysSmall,
}: {
  ad: AdLabelRibbonProps;
  alwaysSmall?: boolean;
}) {
  return (
    <Box>
      {ad.isUrgent && !ad.isSold ? (
        <Ribbon
          backgroundColor={BRAND_COLOR}
          alwaysSmall={alwaysSmall}
          orientation="left"
        >
          URGENT
        </Ribbon>
      ) : (
        <>
          {ad.adTypeLabel && (
            <Ribbon
              backgroundColor="black"
              alwaysSmall={alwaysSmall}
              orientation="left"
            >
              <small>{ad.adTypeLabel.toUpperCase()}</small>
            </Ribbon>
          )}
        </>
      )}
    </Box>
  );
}
